export default __webpack_public_path__ + "06358c18b2392d7b407b1eb324f6166f.otf";